import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Menu.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';


const Menu = () => {

    const navigate = useNavigate();

    return (
        <div>
            <Header></Header>
            <section className="menu-bg d-flex justify-content-center align-items-center vh-100 ">
                <div className="d-lg-flex justify-content-center align-items-center restaurant-btns">
                    <div>
                        <button onClick={() => navigate('/menu/cronulla')} className="btn btn-lg btn-dark rounded-pill" style={{
                            width: 250,
                            background: 'black'
                        }}>
                            <span className="me-2 m-0">Cronulla</span>
                            <FontAwesomeIcon className="m-0" icon={faCircleArrowRight} />
                        </button>
                    </div>
                    <div>
                        <button onClick={() => navigate('/menu/kogarah')} className="btn btn-lg btn-dark rounded-pill mt-2 mt-lg-0 ms-lg-3" style={{
                            width: 250,
                            background: 'black'
                        }}>
                            <span className="me-2 m-0">Kogarah</span>
                            <FontAwesomeIcon className="m-0" icon={faCircleArrowRight} />
                        </button>
                    </div>

                    <div>
                        <button onClick={() => navigate('/menu/parramatta')} className="btn btn-lg btn-dark rounded-pill mt-2 mt-lg-0 ms-lg-3" style={{
                            width: 250,
                            background: 'black'
                        }}>
                            <span className="me-2 m-0">Parramatta</span>
                            <FontAwesomeIcon className="m-0" icon={faCircleArrowRight} />
                        </button>
                    </div>

                </div>
            </section>
            <Footer></Footer>
        </div>
    );
};

export default Menu;